export default function dateid() {
  let date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  const prefix = date.toISOString().replace(/[^0-9]/g, '');
  const suffix = Math.floor(Math.random() * 90000) + 10000;
  return `${prefix}${suffix}`;
}